import React, { useState,useRef } from "react";
import  {Serviceoffered }  from '../constant/data'
import { ToastContainer, toast } from 'react-toastify';
import emailjs from '@emailjs/browser';
import 'react-toastify/dist/ReactToastify.css';
function Form() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    service: "",
    timePeriods: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const form = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Create a FormData object and populate it with form data
      const formDataObject = new FormData(form.current);

      // Map the FormData to the state object
      const data = {};
      formDataObject.forEach((value, key) => {
        data[key] = value;
      });
      setFormData(data);
// console.log(data);
      // Send the email using EmailJS
      const result = await emailjs.sendForm(
        "service_qsvlxdd",
        "template_3tp0qzq",
        form.current,
        "GgcIHmOChlLGj8Btr"
      );

      toast.success("Thank you for your request! We will get back to you soon.", {
       
      });

      console.log("Email sent:", result.text);

      setFormData({
        name: "",
        email: "",
        service: "",
        timePeriods: "",
        message: "",
      });

    } catch (error) {
      toast.error("An error occurred while sending your request. Please try again.");
      console.error("Email sending error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
<div>
<ToastContainer/>
       {/* Booking Start */}
       <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        <div className="booking p-5">
          <div className="row g-5 align-items-center">
            <div className="col-md-6 text-white">
              <h6 className="text-white text-uppercase">Booking</h6>
              <h1 className="text-white mb-4">Online Booking</h1>
              <p className="mb-4">
              At NagsPro, we offer personalized consultations to help you navigate your software development, 
              IT services, and business growth needs. Our team of experts is ready to assist you in identifying 
              the best solutions tailored to your specific goals. Booking a consultation is easy—simply choose a 
              time that works for you through our online scheduling system, and connect with our professionals at 
              your convenience. Whether you're seeking guidance on a project, technical advice, or insights into 
              how our services can help your business thrive, we’re here to assist you every step of the way. 
              Book your consultation today and take the first step toward achieving your goals with NagsPro!
              </p>
            
              <a className="btn btn-outline-light py-3 px-5 mt-2" href="/booking">
                Read More
              </a>
            </div>
            <div className="col-md-6">
              <h1 className="text-white mb-4">Book a consultation</h1>
              <form ref={form} onSubmit={sendEmail} >
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        className="form-control bg-transparent text-white"
                        type="text"
                       id="name"
                       name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="name"  className="text-white">Your Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        className="form-control bg-transparent text-white"
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="Your Email"
                      />
                      <label htmlFor="email"  className="text-white">Your Email</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      className="form-floating date text-white"
                      id="date3"
                      data-target-input="nearest"
                    >
                        <input
                         className="form-control bg-transparent datetimepicker-input text-white"
                         type="date"
                         id="timePeriods"
                         name="timePeriods"
                         value={formData.timePeriods}
                         onChange={handleChange}
                         required
                      />
                      <label htmlFor="datetime">Date &amp; Time</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <select
                        className="form-select bg-transparent text-white"
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                        required
                      >
                         <option value="" disabled>
              -- Select a Service --
            </option>
            {Serviceoffered.map((option) => (
  <option key={option.value} value={option.value} style={{ backgroundColor: '#111111' }}>
    {option.label}
  </option>
))}
                      </select>
                      <label htmlFor="select1" className="text-white">Selecct Service</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control bg-transparent text-white"
                        // placeholder="Special Request"
                        id="message"
                        name="message"
                        placeholder="Write any specific details or questions"
                        value={formData.message}
                        onChange={handleChange}
                        style={{ height: 100 }}
                        defaultValue={""}
                      />
                      <label htmlFor="message"  className="text-white">Special Request</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-outline-light w-100 py-3"
                      type="submit" disabled={isLoading}
                    >
                         {isLoading ? "Sending..." : "Book Now"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Booking Start */}

</div>
  )
}

export default Form